import React from 'react'
import { Main } from '../../../components/dashboard/Main';

export const JournalPage = () => {
  return (
    <div className="journal">
      <div className="journal__container">
        <Main/>
      </div>
    </div>
  )
}
